export default "__VITE_ASSET__AKQwPD3l__"